<div class="flex-display height-100per" role="main" aria-label="cross-reference">
  <div class="flex-display height-100per">
  <div class="width-77">
    <div class="left-scrollbar"  id="scrollList">
      <div class="pl-5per pr-5per search_padding_top">

        <div class="pendingheading">{{stt_header}}</div>
        <div *ngIf="stt_maintenanceflag && stt_maintenanceMessage.length != 0" [innerHTML]="stt_maintenanceMessage">
        </div>
        <div class="mt-2 flex-display mb-1">
          <label class="ml-8 para-content content-blue">{{stt_subtitle}}</label>
        </div>
        <div class="flex-display mb-24px info-box info-box-width my-1" *ngIf="stt_info && stt_info[0]">
          <div><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
          <label class="ml-0-5 para-content content-blue">{{stt_info}}</label>
        </div>
        <!-- Search section -->
        <mat-radio-group class="flex-display">
          <div *ngFor="let Tabs of TabSequence">
            <div *ngIf="Tabs=='Original Pronouncements'" class="p-1-25 search_area_highlight" id="Standard">
              <mat-radio-button id="radio_op" color="primary" class="contact-support-radio-button" value="OP" (change)="onSearchOptionChange('OP')" (click)="CodificationForm.reset({}); CIGForm.reset({})" [checked]="radioOP">{{stt_byOriginalPronouncement}}</mat-radio-button>
            </div>
            <div *ngIf="Tabs=='Codification'" class="p-1-25" id="Codification">
              <mat-radio-button id="radio_cod" color="primary" class="contact-support-radio-button" value="COD" (change)="onSearchOptionChange('COD')" (click)="OpForm.reset({}); CIGForm.reset({})" [checked]="radioCOD">{{stt_byCodification}}</mat-radio-button>
            </div>
            <div *ngIf="Tabs=='Comprehensive Implementation Guide' && !hideCIGFromSTT" class="p-1-25 width-100" id="CIG">
              <mat-radio-button id="radio_cig" color="primary" class="contact-support-radio-button" value="CIG" (change)="onSearchOptionChange('CIG')" (click)="CodificationForm.reset({}); OpForm.reset({})" [checked]="radioCIG">{{stt_byCIG}}</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
        <div>

        </div>
        <!-- button section -->
        <div *ngIf="Op_form_enable && !Cod_form_enable && !CIG_form_enable">
          <form [formGroup]="OpForm" class="search_area_highlight">
            <mat-form-field class="width-20 mt-2 ml-1" appHostListenerClick>
              <mat-label>{{stt_pronouncementtype}}</mat-label>
              <mat-select formControlName="PronouncementType" ngModel (selectionChange)="onPronouncementChange($event)">
                <mat-option *ngFor="let type of SectionTitleList" [value]="type.key">
                  {{type.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-20 mt-2 ml-1" appHostListenerClick>
              <mat-label>{{stt_number}}</mat-label>
              <mat-select [disabled]="enableNumber" formControlName="Number" ngModel>
                <mat-option *ngFor="let number of SectionNumberList" [value]="number.key">
                  {{number.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!--<mat-form-field class="width-20 mt-2 ml-1" *ngIf="!hideCIGFromSTT" appHostListenerClick>
              <mat-label>{{stt_referencetype}}</mat-label>
              <mat-select [disabled]="enableNumber" formControlName="ParaType" ngModel (selectionChange)="onOPTypeChange($event)">
                <mat-option *ngFor="let type of ParaTypeList" [value]="type.key">
                  {{type.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-25 mt-2 ml-1" *ngIf="!hideCIGFromSTT">
              <mat-label>{{OPTypeSelected}}</mat-label>
              <input matInput type="text" formControlName="TypeValue" [placeholder]="OPPlaceholder" ngModel>
            </mat-form-field>-->
          </form>
        </div>
        <div *ngIf="!Op_form_enable && Cod_form_enable && !CIG_form_enable">
          <form [formGroup]="CodificationForm" class="search_area_highlight">
            <mat-form-field class="width-20 mt-2 ml-1">
              <mat-label>{{stt_section}}</mat-label>
              <input matInput type="text" formControlName="Section" [(ngModel)]="CodificationForm_Section" [placeholder]="CODSectionPlaceholder">
            </mat-form-field>


            <!--<mat-form-field class="width-20 mt-2 ml-1" *ngIf="!hideCIGFromSTT">
              <mat-label>{{stt_referencetype}}</mat-label>
              <mat-select [disabled]="CodificationForm_Section == '' || CodificationForm_Section == undefined" formControlName="CODType" [(ngModel)]="CODReferenceTypeValueNgmodel" (selectionChange)="onCODTypeChange($event)">
                <mat-option *ngFor="let type of ParaTypeList" [value]="type.key">
                  {{type.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-25 mt-2 ml-1" *ngIf="!hideCIGFromSTT">
              <mat-label>{{CODTypeSelected}}</mat-label>
              <input matInput type="text" formControlName="TypeValue" [placeholder]="CODPlaceholder" [(ngModel)]="CODformTypeValueNgmodel">
            </mat-form-field>-->
          </form>
        </div>
        <div *ngIf="!Op_form_enable && !Cod_form_enable && CIG_form_enable">
          <form [formGroup]="CIGForm" class="search_area_highlight">
            <mat-form-field class="width-20 mt-2 ml-1" appHostListenerClick>
              <mat-label>{{stt_chapter}}</mat-label>
              <mat-select formControlName="Chapter" [(ngModel)]="CIGForm_Chapter">
                <mat-option *ngFor="let type of SectionNumberList" [value]="type.key">
                  {{type.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!--<mat-form-field class="width-20 mt-2 ml-1" appHostListenerClick>
              <mat-label>{{stt_referencetype}}</mat-label>
              <mat-select [disabled]="CIGForm_Chapter == '' || CIGForm_Chapter == undefined" formControlName="CIGType" ngModel (selectionChange)="onCIGTypeChange($event)">
                <mat-option *ngFor="let type of ParaTypeList" [value]="type.key">
                  {{type.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-25 mt-2 ml-1">
              <mat-label class="watermark">{{CIGTypeSelected}}</mat-label>
              <input matInput type="text" formControlName="TypeValue" [placeholder]="CIGPlaceholder" ngModel>
            </mat-form-field>-->
          </form>
        </div>

        <div>
          <mat-radio-group aria-label="Select an option" [(ngModel)]="isPrimary" (ngModelChange)="primaryRadioButtonChange($event)">
            <div class="mb-1 mt-1rem ml-0-5">
              <mat-radio-button color="primary" class="contact-support-radio-button" value="primary" [checked]="isPrimary=='primary'">{{stt_excludesources}}</mat-radio-button>
            </div>
            <div class="mb-1 mt-1rem ml-0-5">
              <mat-radio-button color="primary" class="contact-support-radio-button" value="non-primary" [checked]="isPrimary=='non-primary'">{{stt_includesources}}</mat-radio-button>
            </div>

          </mat-radio-group>
        </div>

        <div class="ptb-1-25">
          <button mat-button [ngStyle]="{'border': (!(CodificationForm.dirty) && !(OpForm.dirty) && !(CIGForm.dirty))? '2px solid #8994A6': '2px solid #005CBF'}" [ngClass]="(!(CodificationForm.dirty) && !(OpForm.dirty) && !(CIGForm.dirty))?'btn-primary-action-add-disabled':'btn-startover-action'" type="reset" [disabled]="!(CodificationForm.dirty) && !(OpForm.dirty) && !(CIGForm.dirty)" (click)="StartOver()">{{stt_startOver}}</button>
          <button mat-button [ngStyle]="{'background-color': (!buttonActive)  ? '#8994A6': '#005CBF'}" class="btn-primary-action-add" type="submit" [disabled]="(!buttonActive)" [ngClass]="(!buttonActive)?'font-white':'btn-primary-action-add'" (click)="GenerateReport(CodificationForm.value,OpForm.value,CIGForm.value)">{{stt_generate}}</button>
        </div>
        <!-- reoprts section -->
        <div *ngIf="generateReport" class="mb-24px">
          <div class="h-1" *ngIf="Op_form_enable">{{stt_reportfor + " " + standformValues}}</div>
          <div class="h-1" *ngIf="Cod_form_enable">{{stt_reportfor + " " + codformValues}}</div>
          <div class="h-1" *ngIf="CIG_form_enable">{{stt_reportfor + " " + cigformValues}}</div>

          <div *ngIf="data">
            <div>
              <app-stt-table [table_Columns]="columnDetails" [table_data]="dataSource_standard_paragraph.data" [table_dataSource]="dataSource_standard_paragraph" [OPColumn]="opColSpan" [CodColumn]="1" [CIGColumn]="1" [Collection]="SearchSection" [hideCIGFromSTTs]="hideCIGFromSTT"></app-stt-table>
            </div>
          </div>
        </div>

        <div [ngClass]="(data && totalResultCount>resultCount)?'align-item-single-line':''">
          <div class="mt-4 width-65" *ngIf="data && totalResultCount>resultCount">
            <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage(CodificationForm.value,OpForm.value,CIGForm.value)">Load more</button>
          </div>
          <div class="links cursor-pointer flex-display pl-11rem float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop">
            <span class="pr-0-5rem mt-3-3rem">Back to Top</span>
            <span>
              <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-3rem" alt="right up">
            </span>
          </div>
        </div>
      </div>
</div>
  </div>
  <div class="al-right">
    <div class="padding-right-overlay">
      <div class="plb-8-16" (click)="openrightpanel($event)"  [innerHTML]="stt_links"></div>
      <div *ngIf="data" class="mt-40px plb-8-16">
        <div class="pt-9rem" [innerHTML]="stt_tablekey"></div>
      </div>
    </div>
  </div>
</div>
</div>
